module.exports = __webpack_public_path__ + "img/hotel_2.8023b5b6.png";